import * as React from 'react';
export const shareSvg = React.forwardRef(function shareSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 6a3 3 0 1 0-2.861-2.096l-3.073 1.92a3 3 0 1 0 0 4.351l3.073 1.921a3 3 0 1 0 .796-1.272L6.86 8.904a2.999 2.999 0 0 0 0-1.808l3.073-1.92A2.99 2.99 0 0 0 12 6Zm0-1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
    }),
  );
});
shareSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var share = {
  category: 'icon',
  colorable: true,
  name: 'share',
  svg: shareSvg,
};
